<template>
  <div>
    <div class="itemEye" @click="toggleBlurEffect" v-if="hasPermission(893)">
           <img :id="idName3"  src="../../assets/bybk.png" style="width:20px;height:11px;"/>
           <img :id="idName4" class="byk" src="../../assets/zyk.png" style="width:20px;height:14px;"/>
    </div>
    <div style="height:15px;"></div>  
    <el-image 
        v-if="isBlur"
        style="width:300px;"
        :class="{ 'blur': isBlur }" 
        :src="src">
    </el-image>
    <el-image  
        v-else
        style="width:300px;"
        :class="{ 'blur': isBlur }" 
        :src="src"
        :preview-src-list="srcList">
       </el-image>
  </div>
</template>
<style scoped lang="scss">

.itemEye{
    z-index: 100;
    height: 16px;
    width: 30px;
    margin-left: 2px;
    cursor: pointer;
    color: #575B6C;
}
.byk{
  display: none;
}
.blur {
    filter:blur(16px);
}
</style>
<script>
import {generateRandomAlphaNumeric} from '@/utils/index'
export default {
    props:{
        src:{
            type:String
        },
        idName3:{
        default() {
             
           const result = generateRandomAlphaNumeric(4)
           return result;       
        },
        },
        idName4:{
            default() {

            const result = generateRandomAlphaNumeric(4)
            return result;       
            },
        },
    },
 mounted(){
    
        if(this.src){
            const dynamicImageUrl = this.src;
            const blurryBackground = document.querySelector('.blur');
            blurryBackground.style.backgroundImage = `url('${dynamicImageUrl}')`;
        }
        
 },
  data() {
    return {
      isBlur: true,
      srcList: [this.src]
    };
  },
  methods: {
    toggleBlurEffect() {
      this.isBlur = !this.isBlur;
      if(this.isBlur){
                $("#"+this.idName3).show();
                $("#"+this.idName4).hide()
        }else{
                $("#"+this.idName3).hide();
                $("#"+this.idName4).show();
               
        }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SensitiveInfo/imageFiltering.vue